// apolo/src/lib/notes/noteStore.js — harness-uplift-r2 E6.
// @arch:pure-engine
//
// Anthropic structured note-taking: the agent persists short notes OUTSIDE the
// context window (a NOTES.md-style string) and reads them back later. This is the
// PURE string engine (append/read, capped, sanitized); the FS persistence is a
// wiring concern handled by the caller. Never throws.

const NOTE_MAX = 500; // per note
const STORE_CAP = 8000; // whole store — oldest notes drop when exceeded

/** Strip control chars (keep \n, \t). */
function sanitize(s) {
  // eslint-disable-next-line no-control-regex
  return String(s || '').replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '').trim();
}

/**
 * Append a note to the store, returning the new store. Sanitized + capped;
 * when the store exceeds STORE_CAP, the OLDEST lines are dropped (FIFO).
 * @param {string} existing
 * @param {string} note
 * @returns {string}
 */
export function appendNote(existing, note) {
  try {
    const clean = sanitize(note).slice(0, NOTE_MAX);
    if (!clean) return typeof existing === 'string' ? existing : '';
    const base = typeof existing === 'string' ? existing : '';
    let next = base ? `${base}\n- ${clean}` : `- ${clean}`;
    if (next.length > STORE_CAP) {
      // drop oldest lines until under cap
      const lines = next.split('\n');
      while (lines.length > 1 && lines.join('\n').length > STORE_CAP) lines.shift();
      next = lines.join('\n');
    }
    return next;
  } catch {
    return typeof existing === 'string' ? existing : '';
  }
}

/** Read the store back as-is (safe string). */
export function readNotes(existing) {
  return typeof existing === 'string' ? existing : '';
}
